import { useField } from "formik";
import styles from "./InputField.module.css";

export const InputField = ({ ...props }) => {
  const [field, meta] = useField(props);
  
  // choosing a class depending on the custom type of the field with props.fieldtype
  const style = `${styles.inputField} ${styles[props.fieldtype]} ${props.className} nexiColor fw-bold`;
  // console.log('field: ', field);
  // console.log('props: ', props)
  return (
    <input
      {...field}
      {...props}
      className={style}
    />

  );
};
